export default {
  //船舶セレクトのOptions
  getManningVesselsOptions: state => {
    return state.manningVessels.map(item => ({
      id: item.id,
      label: item.name,
    }));
  },

  //直近の締日
  getLatestCutoffDate: state => {
    return state.latestCutoffDate;
  },

  //船員マスターリポジトリ
  getEnterpriseCrews: state => {
    return state.enterpriseCrews.map(item => ({
      id: item.id,
      label: item.name,
    }));
  },
};
